<app-tool-loader [isLoading]="isLoading()" [positionUnset]="true">
  <div class="flex flex-col h-full">
    <!-- Controls Toolbar -->
    <p-toolbar>
      <ng-template #start>
        <div class="flex gap-3 items-center">
          <p-select 
            inputId="packer-select"
            class="w-32"
            [ngModel]="selectedPackerIndex()"
            (onChange)="onPackerChange($event.value)"
            [options]="packers()"
            optionLabel="label"
            optionValue="value"
            placeholder="Select packer"
            appendTo="body"
            pTooltip="Packer">
          </p-select>

          <p-select 
            inputId="load-case-select"
            class="w-40"
            [ngModel]="selectedLoadCase()"
            (onChange)="onLoadCaseChange($event.value)"
            [options]="loadCases()"
            optionLabel="label"
            optionValue="value"
            placeholder="Select load case"
            appendTo="body"
            pTooltip="Load Case">
          </p-select>

          <p-select 
            inputId="display-mode"
            style="width: 150px"
            [ngModel]="selectedMode()"
            (onChange)="onModeChange($event.value)"
            [options]="displayModes"
            optionLabel="label"
            optionValue="value"
            placeholder="Select mode"
            appendTo="body"
            pTooltip="Display Mode">
          </p-select>

          <p-button
            text
            size="small"
            icon="pi pi-download"
            pTooltip="Download as PNG"
            (onClick)="onExportPng()"
          ></p-button>

          @if (showExpansionJointFocusToggle()) {
            <div class="flex items-center gap-2">
              <p-selectButton
                [ngModel]="selectedExpansionJointFocus()"
                [options]="expansionJointFocusOptions"
                optionLabel="label"
                optionValue="value"
                (onChange)="onExpansionJointFocusChange($event.value)"
                ariaLabel="Expansion joint focus"
                [allowEmpty]="false"
                pTooltip="Expansion Joint Focus">
              </p-selectButton>
              <i
                class="pi pi-info-circle text-muted-color cursor-help relative z-[2]"
                pTooltip="Shown only for true telescoping expansion joints (EJ enabled and depth set away from packer depth)."
              ></i>
            </div>
          }
          
        </div>
      </ng-template>
    </p-toolbar>

    <!-- Schematic Display -->
    <div 
      #schematicContainer
      id="packer-schematic-viewer-container"
      [class.panning]="isPanning()"
      class="flex-1 border rounded-lg bg-surface-0 min-h-0"
      pTooltip="Scroll to Zoom, Drag to Pan, Double-click to Reset, Right-click to Copy"
      (dblclick)="resetView()"
      (contextmenu)="onPackerViewerContextMenu($event)"
      (wheel)="onMouseWheel($event)"
      (mousedown)="onMouseDown($event)"
      (mouseup)="onMouseUp()"
      (mousemove)="onMouseMove($event)">
      
      @if (errorMessage()) {
        <div class="text-red-500 p-4 text-center">
          <i class="pi pi-exclamation-triangle mr-2"></i>
          {{ errorMessage() }}
        </div>
      }

      @if (!errorMessage() && svgContent()) {
        <div
          class="w-full h-full"
          [innerHTML]="svgContent() | sanitizeHtml"
        ></div>
      }

      @if (!errorMessage() && !svgContent() && !isLoading()) {
        <div class="text-muted-color p-4 text-center">
          <i class="pi pi-info-circle mr-2"></i>
          <label>Select a packer, load case and display mode to view schematic</label>
        </div>
      }
    </div>
  </div>
</app-tool-loader>

<p-contextMenu #packerViewerCm [model]="packerViewerContextMenuItems()" appendTo="body"></p-contextMenu>
